import React from 'react'
import { Box } from '@react-three/drei'
import { ADUModel as ADUModelType } from '../../../store/designStore'

interface ADUModelProps extends ADUModelType {
  onClick?: () => void
  onPointerDown?: (event: any) => void
  isSelected?: boolean
  isDragging?: boolean
}

const ADUModel: React.FC<ADUModelProps> = ({ 
  position, 
  rotation, 
  scale, 
  dimensions, 
  materials, 
  onClick,
  onPointerDown,
  isSelected = false,
  isDragging = false
}) => {
  return (
    <group 
      position={position} 
      rotation={rotation} 
      scale={isDragging ? [scale[0] * 1.05, scale[1] * 1.05, scale[2] * 1.05] : scale} 
      onClick={onClick}
      onPointerDown={onPointerDown}
    >
      {/* Selection outline */}
      {isSelected && (
        <Box
          args={[dimensions.width + 0.5, dimensions.height + 0.5, dimensions.depth + 0.5]}
          position={[0, dimensions.height / 2, 0]}
        >
          <meshBasicMaterial 
            color={isDragging ? "#ff6b00" : "#00ff00"} 
            wireframe 
            transparent 
            opacity={isDragging ? 0.8 : 0.7} 
          />
        </Box>
      )}
      
      {/* Main structure */}
      <Box
        args={[dimensions.width, dimensions.height, dimensions.depth]}
        position={[0, dimensions.height / 2, 0]}
        castShadow
        receiveShadow
      >
        <meshStandardMaterial color={materials.walls} />
      </Box>
      
      {/* Roof */}
      <Box
        args={[dimensions.width + 1, 1, dimensions.depth + 1]}
        position={[0, dimensions.height + 0.5, 0]}
        castShadow
      >
        <meshStandardMaterial color={materials.roof} />
      </Box>
      
      {/* Door */}
      <Box
        args={[0.1, 6, 2]}
        position={[dimensions.width / 2, 3, 0]}
        castShadow
      >
        <meshStandardMaterial color={materials.door} />
      </Box>
      
      {/* Windows */}
      <Box
        args={[0.1, 2, 2]}
        position={[dimensions.width / 2, 4, dimensions.depth / 3]}
        castShadow
      >
        <meshStandardMaterial color={materials.windows} />
      </Box>
      <Box
        args={[0.1, 2, 2]}
        position={[dimensions.width / 2, 4, -dimensions.depth / 3]}
        castShadow
      >
        <meshStandardMaterial color={materials.windows} />
      </Box>
    </group>
  )
}

export default ADUModel